import { render, staticRenderFns } from "./TheNoticeModal.vue?vue&type=template&id=31aeb8ea&"
import script from "./TheNoticeModal.vue?vue&type=script&lang=js&"
export * from "./TheNoticeModal.vue?vue&type=script&lang=js&"
import style0 from "./TheNoticeModal.vue?vue&type=style&index=0&id=31aeb8ea&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports